profileApp.controller('contactCtrl', function($scope, user, contactType, confirmationCode) {
    $scope.user = user;
    $scope.contactType = contactType;
    $scope.confirmationCode = confirmationCode

})
